module.exports = __webpack_public_path__ + "img/upload.10bd072b.svg";